import http from "~/common/http";

export const CustomerTrace = {
    id: "",
    customer_id: "",
    product_id: "",
    contact_id: "",
    content: "",
    next_time: "",
};

function pad(value) {
    return value < 10 ? "0" + value : String(value);
}

/**
 * Keep the selected local time when serializing a trace request.
 * Axios otherwise serializes Date values as UTC ISO strings.
 */
export function normalizeNextTime(data) {
    const payload = Object.assign({}, data);
    if (!payload.next_time) {
        return payload;
    }

    const date = payload.next_time instanceof Date
        ? payload.next_time
        : new Date(payload.next_time);
    if (isNaN(date.getTime())) {
        return payload;
    }

    payload.next_time = [
        date.getFullYear(),
        pad(date.getMonth() + 1),
        pad(date.getDate())
    ].join("-") + " " + [
        pad(date.getHours()),
        pad(date.getMinutes()),
        pad(date.getSeconds())
    ].join(":");

    return payload;
}

export default {

    getList(params) {
        return http.get('/api/customer/traces/index', {
            params: params
        });
    },

    create(data) {
        return http.post("/api/customer/traces/create", normalizeNextTime(data));
    },

    delete(traceId) {
        return http.delete("/api/customer/traces/delete", {
            params: {
                id: traceId
            }
        });
    }


}



// WEBPACK FOOTER //
// ./src/services/CustomerTrace.js